module.exports = __webpack_public_path__ + "img/sakegacha_spark.a495eb63.jpg";